import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { AlertCircle, ArrowLeft } from 'lucide-react';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(email, password);
    setLoading(false);

    if (result.success) {
      navigate('/');
    } else {
      setError(result.error);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#EDE8DC] px-6 py-12">
      <div className="w-full max-w-md">
        {/* Back to home — discrete, top-left of the card */}
        <Link
          to="/"
          className="inline-flex items-center gap-1.5 text-xs uppercase tracking-widest text-[#5D4E37]/70 hover:text-[#D4A574] transition-colors mb-4"
          data-testid="login-back-home"
        >
          <ArrowLeft className="w-3.5 h-3.5" />
          Retour à l&apos;accueil
        </Link>

        <div className="bg-white rounded-sm shadow-md p-8">
          {/* Header */}
          <div className="text-center mb-8">
            <h2 className="text-3xl font-serif font-semibold text-[#5D4E37] mb-2">
              Connexion
            </h2>
            <p className="text-sm text-[#5D4E37]/70 font-light">
              Accédez à votre espace personnel
            </p>
          </div>

          {/* Error Alert */}
          {error && (
            <div className="mb-6 p-4 bg-red-50 border border-red-200 rounded-sm flex items-start">
              <AlertCircle className="w-5 h-5 text-red-600 mr-3 flex-shrink-0 mt-0.5" />
              <p className="text-sm text-red-800">{error}</p>
            </div>
          )}

          {/* Login Form */}
          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label htmlFor="email" className="block text-sm font-light text-[#5D4E37] mb-2">
                Email
              </label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="votre@email.com"
                required
                className="w-full"
              />
            </div>

            <div>
              <label htmlFor="password" className="block text-sm font-light text-[#5D4E37] mb-2">
                Mot de passe
              </label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                required
                className="w-full"
              />
            </div>

            <Button
              type="submit"
              disabled={loading}
              className="w-full bg-[#5D4E37] hover:bg-[#6B5D4F] text-white font-light"
            >
              {loading ? 'Connexion...' : 'Se connecter'}
            </Button>
          </form>

          {/* Links */}
          <div className="mt-6 space-y-3">
            <Link
              to="/forgot-password"
              className="block text-center text-sm text-[#D4A574] hover:text-[#5D4E37] font-light"
            >
              Mot de passe oublié ?
            </Link>
            <div className="text-center text-sm text-[#5D4E37]/70 font-light">
              Pas encore de compte ?{' '}
              <Link to="/register" className="text-[#D4A574] hover:text-[#5D4E37] font-normal">
                S'inscrire
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;